/**
 * Login Page
 * Standalone login page with navigation to dashboard on success
 *
 * Requirements: 2.1, 2.4
 */

import { useNavigate } from 'react-router-dom';
import LoginForm from '../components/auth/LoginForm';

const Login = () => {
  const navigate = useNavigate();

  const handleLoginSuccess = () => {
    // Requirement: 2.4 - Redirect to dashboard after successful login
    // Role-based dispatch happens in DashboardGate (App.js routing layer)
    navigate('/dashboard');
  };

  const handleRequire2FA = (email) => {
    // TODO: Handle 2FA flow in future task
    console.log('2FA required for:', email);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#EAF4FB] to-white flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-[#17386E] mb-2">Connexion</h1>
            <p className="text-gray-600">Accédez à votre compte MyEduCycle</p>
          </div>

          <LoginForm
            onSuccess={handleLoginSuccess}
            onRequire2FA={handleRequire2FA}
          />

          <div className="mt-6 text-center">
            <p className="text-sm text-gray-600">
              Pas encore de compte?{' '}
              <a href="/register" className="text-[#17386E] hover:text-[#4CE0C2] font-semibold">
                S'inscrire
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
